export default {
  appTitle: 'LoanKnow - Dev',
  apiUrl: 'https://api.dev.go.uff.pro/api',
  appEnv: 'staging',
  useMockServices: false,
  googleClientId: '531776166755-vqvlcc4r450gj5l97fflq1tn8s5akhoq.apps.googleusercontent.com',
  microsoftClientId: 'b34f8ab1-ee4d-46cb-b160-fcda3d0bbd72',
  microsoftTenantId: 'common',
  supabaseUrl: 'https://pvzqgboffydqeqzeiysx.supabase.co',
  supabaseAnonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB2enFnYm9mZnlkcWVxemVpeXN4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE2MjU4NjcsImV4cCI6MjA4NzIwMTg2N30.gVgxdlVF3lnvoL8BSPOngx15fwBibiRx9VLtuL3z12I',
};
